import { render, staticRenderFns } from "./Remark.vue?vue&type=template&id=127a7230&scoped=true"
import script from "./Remark.vue?vue&type=script&lang=js"
export * from "./Remark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a7230",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('127a7230')) {
      api.createRecord('127a7230', component.options)
    } else {
      api.reload('127a7230', component.options)
    }
    module.hot.accept("./Remark.vue?vue&type=template&id=127a7230&scoped=true", function () {
      api.rerender('127a7230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/costManagement/costsFee/cmp/Remark.vue"
export default component.exports